import { ProjectCompletionsParameterBase } from './base/project-completions-parameter-base';

export class ProjectCompletionsParameter extends ProjectCompletionsParameterBase { }